import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { usePagination } from '@/hooks';
import { Table } from '@/components';
import { useEffect } from 'react';

import {
  statusesForFilter,
  type IntegrationRequest,
  type IntegrationRequestFilters,
} from '../../../../models/IntegrationRequest';
import { useGetIntegrationRequestsQuery } from '../../../../services';
import { integrationRequestsTableColumns } from '../../../../config';
import { INTEGRATION_REQUESTS_PATH } from '../../config';

const IntegrationRequestsTable = ({ filters }: { filters: IntegrationRequestFilters }) => {
  const navigate = useNavigate();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } = usePagination({});

  useEffect(() => {
    handlePageChange(1);
  }, [filters, handlePageChange]);

  const { data, isLoading, isFetching, error } = useGetIntegrationRequestsQuery({
    statuses: statusesForFilter(filters.status),
    type: filters.type,
    page: currentPage,
    pageSize,
  });

  const requests = data?.items ?? [];
  const totalItems = data?.count ?? 0;
  const isBusy = isLoading || isFetching;

  if (error) {
    return (
      <div className='text-center py-8'>
        <p className='text-red-600'>Error al cargar las solicitudes de integración</p>
      </div>
    );
  }

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5'>
      {isBusy || requests.length > 0 ? (
        <Table
          data={requests}
          columns={integrationRequestsTableColumns}
          isLoading={isBusy}
          skeletonRows={Math.min(pageSize, 10)}
          renderActions={(row: IntegrationRequest) => (
            <IconButton
              onClick={() => navigate(`${INTEGRATION_REQUESTS_PATH}/${row.id}`)}
              size='small'
            >
              <VisibilityIcon fontSize='small' />
            </IconButton>
          )}
          pagination={{
            totalItems,
            totalPages: Math.ceil(totalItems / pageSize),
            currentPage,
            rowsPerPage: pageSize,
            onPageChange: handlePageChange,
            onRowsPerPageChange: handlePageSizeChange,
          }}
        />
      ) : (
        <div className='text-center text-gray-500 py-8'>
          No hay solicitudes con esos filtros
        </div>
      )}
    </div>
  );
};

export default IntegrationRequestsTable;
